module.exports = __webpack_public_path__ + "media/images/head_point30-6d6f797e250a6609f84abdd3f7c194ed.svg";